<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div class="chukoubianjing">
    <titles class="biaoti3" :title="title"></titles>
    <div class="paiming2">
      <p class="biaoti">
        本市跨境贸易的平均审核时间为2天,评价得分为80分,与第一名上海比较多1天时间,在对标城市中排名第2
      </p>
      <div class="paimingk">
        <div ref="myChart6" style="width: 490px;height: 400px"></div>
        <div ref="myChart7" style="width: 490px;height: 400px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "paiming",
  components: {titles},
  data: function () {
    return {
      list: [],
    }
  },
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      // let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let myChart = this.$echarts.init(this.$refs.myChart6)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '0',
          bottom: '19%'
        },
        title: {
          text: '审核耗时',
          x: '170',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,

            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [1.5, 1, 0.5, 1],
          barWidth: '40px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            formatter: "{c}" + "天",
            show: true,
            position: "top",
            textStyle: {
              fontWeight: "bolder",
              fontSize: "28",
              color: "#fff"
            }
          },
        }
        ]
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.myChart7)
      // let myChart = this.$echarts.init(document.getElementById('myChart7'))
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '0%',
          bottom: '19%'
        },
        title: {
          text: '审核费用',
          x: '170',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 30
          }
        },

        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(111, 118, 142, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,

            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [217, 211, 187, 213],
          barWidth: '40px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            formatter: "{c}" + "元",
            show: true,
            position: "top",
            textStyle: {
              fontWeight: "bolder",
              fontSize: "28",
              color: "#fff"
            }
          },
        }
        ]
      });
    },

  },
  mounted() {
    this.drawLine();
    this.drawLine2();
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.biaoti {
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-bottom: 30px;
}

.paimingk {
  @include flex_start_start();
}

.paiming4 {
  margin-left: 30px;
  @include flex_center_center();
  margin-top: 0px;
  width: 600px;
}

.chukoubianjing {
  width: 988px;
}

.biaoti3 {
  height: 137px;
}
</style>
